import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loadContext } from '../../store/actions/Contexto';
import { isAfterDataProvaFase1, isPeriodoInscricoes } from '../../helper/ContextHelper';

import Grid from '@material-ui/core/Grid';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import LaptopMacIcon from '@material-ui/icons/LaptopMac';
import DescriptionIcon from '@material-ui/icons/Description';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import VpnKeyOutlinedIcon from '@material-ui/icons/VpnKeyOutlined';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import HighlightOffOutlinedIcon from '@material-ui/icons/HighlightOffOutlined';
import PlaylistAddOutlinedIcon from '@material-ui/icons/PlaylistAddOutlined';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenOutlinedIcon from '@material-ui/icons/LockOpenOutlined';

import EscolaService from '../../services/Escola';
import InscricaoService from '../../services/Inscricao';
import { errors } from '../../services/API';

import { patternSchools } from '../../variables/Enums/Escola';

import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import Title from '../../components/Title/Title';
import Table from '../../components/Table/Table';
import Toast from '../../components/Toast/Toast';
import {
  verifyPagingAndSorting,
  PAGE,
  SIZE,
  ASC,
  TOTAL_ELEMENTS,
  TOTAL_PAGES,
} from '../../components/Table/Utils';

import EscolaFilter from '../../forms/Escola/EscolaFilter';
import { ButtonExport } from '../../forms/Buttons/ButtonsExport';
import { ButtonAdd } from '../../forms/Buttons/ButtonsAdd';
import DialogChangePassword from '../../forms/Dialog/DialogChangePassword';
import { DialogConfirm as DialogHabilitarDownloadFase2 }  from '../../forms/Dialog/DialogConfirm';
import {
  DialogRemove as DialogRemoverEscola,
  DialogRemove as DialogRemoverInscricao
} from '../../forms/Dialog/DialogRemove';

import { makeStyles } from '@material-ui/core/styles';

import { evasaoLimiterMask } from '../../helper/MaskHelper';
import { verifyPersistence, removePagingAndSorting } from '../../helper/PaginationHelper';

import AuthorizedFunction from '../../security/AuthorizedFunction';
import AuthorizedElement from '../../security/AuthorizedElement';
import {
  __ESCOLA_ADICIONAR,
  __ESCOLA_EXPORTAR,
  __ESCOLA_EDITAR,
  __ESCOLA_DASHBOARD,
  __ESCOLA_EDITAR_SENHA,
  __ESCOLA_RESPONSAVEL_EDITAR,
  __ESCOLA_REMOVER,
  __INSCRICAO_REMOVER,
  __RECIBO_ESCOLA,
} from '../../security/RoleConfiguration';

import { Layout } from '../../layouts/private/Private';

export const useStyles = makeStyles(theme => ({
  body: {
    margin: theme.spacing(3, 0),
  },
}));

export class Escola extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: PAGE,
      size: SIZE,
      totalElements: TOTAL_ELEMENTS,
      totalPages: TOTAL_PAGES,
      sort: [{ orderBy: 'cdMecEscola', order: ASC }],
      defaultOrderBy: 'cdMecEscola',
      filtered: false,
      filters: [],
      schools: [],
      loading: true,
      sendToSchools: [],
      loadingButtonSave: false,
      jaFezBuscaDaUrl: false,
    }

    this.state = verifyPersistence(this.state, this.props.location);
  }

  // DECLARAÇÃO DE REFERÊNCIA DOS COMPONENTES
  setToast = t => this.Toast = t;
  setEscolaFilter = f => this.EscolaFilter = f;
  setDialogRemoverInscricao = r => this.DialogRemoverInscricao = r;
  setDialogRemoverEscola = r => this.DialogRemoverEscola = r;
  setDialogChangePassword = f => this.DialogChangePassword = f;
  setDialogHabilitarDownloadFase2 = d => this.DialogHabilitarDownloadFase2 = d;

  // EDIÇÃO
  handleEditClick = id => {
    this.props.history.push({
      pathname: `/admin/escola/${id}/editar`,
      state: {
        history: {
          path: `/admin/escola`,
          state: this.state,
        }
      }
    });
  }

  // EDIÇÃO
  handleInscreverClick = id => {
    this.props.history.push({
      pathname: `/admin/escola/${id}/inscrever`,
      state: {
        history: {
          path: `/admin/escola`,
          state: this.state,
        }
      }
    });
  }

  // LABELS
  labelEscolaSemInscricao = "Escola sem Inscrição";
  labelEscolaInscrita = "Escola Já Inscrita";
  labelSemPermissao = "Você não tem permissão para fazer isso";
  labelEscolaNaoTratada = "A Escola Ainda Não Tratada ou Foi Tratada Como Inválida";
  labelForaPeriodoInscricao = "Estamos Fora do Período de Inscrições";

  labelDownloadFase2 = id => !this.disabledDownloadFase2(id) ? `${this.verificarSeEscolaPodeAcessarDownloadFase2(id) ? "Desabilitar" : "Habilitar"} Acesso ao Download de Material da Fase 2` : !this.habilitarDownloadFase2(id) ? this.labelEscolaSemInscricao : this.labelSemPermissao;
  labelEditar = id => !this.disabledEditar(id) ? "Editar" : this.labelSemPermissao;
  labelInscrever = id => !this.disabledInscrever(id) ? "Inscrever" : !this.isEscolaValida(id) ? this.labelEscolaNaoTratada : !isPeriodoInscricoes(this.props.contexts) ? this.labelForaPeriodoInscricao : this.isEscolaInscrita(id) ? this.labelEscolaInscrita : this.labelSemPermissao;
  labelAtualizarSenha = id => !this.disabledAtualizarSenha(id) ? "Alterar Senha" : !this.habilitarAtualizarSenha(id) ? this.labelEscolaSemInscricao : this.labelSemPermissao;
  labelResponsavel = id => !this.disabledResponsavel(id) ? "Editar Responsável pela Inscrição" : !this.habilitarEdicaoResponsavel(id) ? this.labelEscolaSemInscricao : this.labelSemPermissao;
  labelRecibo = id => !this.disabledRecibo(id) ? "Ver Recibo de Escola" : !this.habilitarRecibo(id) ? this.labelEscolaSemInscricao : this.labelSemPermissao;
  labelDashboard = id => !this.disabledDashboard(id) ? "Ver Dashboard" : !this.habilitarVisaoDashboard(id) ? this.labelEscolaSemInscricao : this.labelSemPermissao;
  labelExcluir = id => !this.disabledExcluir(id) ? "Excluir Escola" : this.labelSemPermissao;
  labelRemoverInscricao = id => !this.disabledRemoverInscricao(id) ? "Remover Inscrição Desta Escola" : !this.habilitarRemoverInscricao(id) ? this.labelEscolaSemInscricao : this.labelSemPermissao;

  // DISABLES
  disabledDownloadFase2 = id => AuthorizedFunction([__ESCOLA_EDITAR]) ? !this.habilitarDownloadFase2(id) : !AuthorizedFunction([__ESCOLA_EDITAR]);
  disabledEditar = id => !AuthorizedFunction([__ESCOLA_EDITAR]);
  disabledInscrever = id => !this.habilitarInscreverEscola(id);
  disabledAtualizarSenha = id => AuthorizedFunction([__ESCOLA_EDITAR_SENHA]) ? !this.habilitarAtualizarSenha(id) : !AuthorizedFunction([__ESCOLA_EDITAR_SENHA]);
  disabledResponsavel = id => AuthorizedFunction([__ESCOLA_RESPONSAVEL_EDITAR]) ? !this.habilitarEdicaoResponsavel(id) : !AuthorizedFunction([__ESCOLA_RESPONSAVEL_EDITAR])
  disabledRecibo = id => AuthorizedFunction([__RECIBO_ESCOLA]) ? !this.habilitarRecibo(id) : !AuthorizedFunction([__RECIBO_ESCOLA]);
  disabledDashboard = id => AuthorizedFunction([__ESCOLA_DASHBOARD]) ? !this.habilitarVisaoDashboard(id) : !AuthorizedFunction([__ESCOLA_DASHBOARD]);
  disabledExcluir = id => !AuthorizedFunction([__ESCOLA_REMOVER]);
  disabledRemoverInscricao = id => AuthorizedFunction([__INSCRICAO_REMOVER]) ? !this.habilitarRemoverInscricao(id) : !AuthorizedFunction([__INSCRICAO_REMOVER]);

  // EXPORTAÇÂO
  handleExportPlan = () => {
    this.EscolaFilter.setState({ filter: true, exportPlan: true, }, () => this.EscolaFilter.handleFilterApply());

    this.Toast.setState({
      message: {
        message: "A Planilha está sendo gerada para Exportação.",
        type: 'info',
        open: true,
        loading: true,
        autoHide: false,
      }
    })
  }

  // EDIÇÃO RESPONSÁVEL
  handleEditResponsibleClick = id => {
    const school = this.state.schools.find(s => s.cdMecEscola === id);
    this.props.history.push({
      pathname: `/admin/escola/${school.cdMecEscola}/responsavel/editar`,
      state: {
        history: {
          path: `/admin/escola`,
          state: this.state,
        }
      }
    })
  }

  // ESCOLA INSCRITA
  isEscolaInscrita = (id) => {
    const school = this.state.schools.find(s => s.cdMecEscola === id);
    return school.idResponsavel && school.isInscrita ? true : false;
  }

  // ESCOLA VALIDA
  isEscolaValida = (id) => {
    const school = this.state.schools.find(s => s.cdMecEscola === id);
    return school.nmStatus === 'VALIDA' ? true : false;
  }

  // VERIFICAR SE O CAMPO PRECISA ESTAR HABILITADO OU DESABILITADO
  habilitarEdicaoResponsavel = id => this.isEscolaInscrita(id);

  // VERIFICAR SE INSCRICAO PODE SER REMOVIDA
  habilitarRemoverInscricao = id => this.isEscolaInscrita(id)

  // ATUALIZAR SENHA
  habilitarAtualizarSenha = id => this.isEscolaInscrita(id)

  // ESCOLA INSCRITA
  habilitarInscreverEscola = id => !this.isEscolaInscrita(id) && this.isEscolaValida(id) && isPeriodoInscricoes(this.props.contexts)

  // ABRIR MODAL DE ATUALIZAR SENHA
  handleOpenAtualizarSenhaClick = id => this.DialogChangePassword.setState({ open: true, id: id });

  // VERIFICAR EXIBIÇÃO DO BOTÃO DE DASHBOARD
  habilitarVisaoDashboard = id => this.isEscolaInscrita(id)

  // VERIFICAR CONTEXTO PARA VER RECIBO  
  habilitarRecibo = id => this.isEscolaInscrita(id) ? true : false;
  
  verificarSeEscolaPodeAcessarDownloadFase2 = (id) => {
    const school = this.state.schools.find(s => s.cdMecEscola === id);
    return school.downloadFase2;
  }

  habilitarDownloadFase2 = (id) => this.isEscolaInscrita(id) && this.isEscolaValida(id);

  // ABRIR MODAL DE CONFIRMAÇÃO DE REMOÇÃO
  handleExcluir = id => {
    const school = this.state.schools.find(s => s.cdMecEscola === id);
    const escolaInscrita = school.isInscrita ? `A Inscrição desta Escola será Desfeita ` : ``;
    this.DialogRemoverEscola.setState({
      dialog: {
        open: true,
        title: `Deseja Remover a Escola ${school.nmEscola} - ${school.cdMecEscola} ?`,
        text: `${escolaInscrita ? `e` : `A`} Escola não poderá ser recuperada depois de ser removida.`,
        id: id,
        loading: false,
      }
    });
  }

  // REMOÇÃO DE ESCOLA
  handleRemoverEscolaConfirm = (id) => {
    this.DialogRemoverEscola.loading();

    EscolaService.remove(id)
      .then(res => {
        this.Toast.setState({
          message: {
            message: "A Escola foi Excluída com Sucesso.",
            type: 'success',
            open: true
          }
        })
      })
      .catch(error => {
        const e = errors(error);
        this.Toast.setState({
          message: {
            message: e.message,
            type: e.type,
            open: true
          }
        })
      })
      .finally(() => {
        this.DialogRemoverEscola.close();
        this.loadData();
      });
  }

  // ABRIR MODAL DE CONFIRMAÇÃO DE REMOÇÃO de INSCRIÇÃO
  handleRemoverInscricao = id => {
    const school = this.state.schools.find(s => s.cdMecEscola === id);
    this.DialogRemoverInscricao.setState({
      dialog: {
        open: true,
        title: `Deseja Remover a Inscrição da Escola ${school.nmEscola} - ${school.cdMecEscola} ?`,
        text: `A Inscrição desta Escola será Desfeita. A Escola Poderá ser Inscrita Novamente com Outras Informações.`,
        id: id,
        loading: false,
      }
    });
  }

  // REMOÇÃO DE INSCRIÇÃO
  handleRemoverInscricaoConfirm = (id) => {
    this.DialogRemoverInscricao.loading();

    InscricaoService.remove(id)
      .then(res => {
        this.Toast.setState({
          message: {
            message: "A Inscrição foi Removida com Sucesso.",
            type: 'success',
            open: true
          }
        })
      })
      .catch(error => {
        const e = errors(error);
        this.Toast.setState({
          message: {
            message: e.message,
            type: e.type,
            open: true
          }
        })
      })
      .finally(() => {
        this.DialogRemoverInscricao.close();
        this.loadData();
      });
  }

  // VER DASHBOARD COMO ESCOLA
  handleViewDashboard = id => {
    const school = this.state.schools.find(s => s.cdMecEscola === id);
    this.props.history.push({
      pathname: `/admin/inicio`,
      state: {
        escola: {
          id: school.cdMecEscola
        }
      }
    });
  }

  // VER RELATÓRIO DE ESCOLA
  handleViewReceipt = (id) => {
    const school = this.state.schools.find(s => s.cdMecEscola === id);
    this.props.history.push({
      pathname: `/admin/inscricao/${school.cdMecEscola}/recibo`,
      state: {
        history: {
          path: `/admin/escola`,
          state: this.state,
        }
      }
    });
  }

  // DIALOG DE HABILITAR DOWNLOAD DE FASE 2
  handleOpenDownloadFase2 = (id) => {
    const school = this.state.schools.find(s => s.cdMecEscola === id);
    this.DialogHabilitarDownloadFase2.setState({
      dialog: {
        open: true,
        title: `Deseja ${this.verificarSeEscolaPodeAcessarDownloadFase2(id) ? "Desabilitar" : "Habilitar"} para a Escola ${school.nmEscola} o Download de Material de Fase 2?`,
        id: id,
        loading: false,
        showConfirm: true,
      }
    });
  }

  handleHabilitarDownloadFase2 = (id) => {
    this.DialogHabilitarDownloadFase2.loading();
    const action = this.verificarSeEscolaPodeAcessarDownloadFase2(id) ? "Desabilitado" : "Habilitado"; 

    EscolaService.downloadFase2(id, !this.verificarSeEscolaPodeAcessarDownloadFase2(id))
      .then(res => {
        this.Toast.setState({
          message: {
            message: `Download de Material de Fase 2 ${action} com Sucesso.`,
            type: 'success',
            open: true
          }
        })
      })
      .catch(error => {
        const e = errors(error);
        this.Toast.setState({
          message: {
            message: e.message,
            type: e.type,
            open: true
          }
        })
      })
      .finally(() => {
        this.DialogHabilitarDownloadFase2.close();
        this.loadData();
      });
  }

  loadData = async () => {
    this.props.loadContext();

    let filters = verifyPagingAndSorting(this.state);

    this.setState({
      filters: [...filters],
      filtered: true,
      loading: true
    });

    if (!this.state.jaFezBuscaDaUrl) {
      const parseFilters = queryString.parse(this.props.location.search);

      if (parseFilters.status) filters.push({ field: 'nmStatus', value: parseFilters.status })

      this.setState({ jaFezBuscaDaUrl: true });
    }

    await EscolaService.filters(filters)
      .then(res => {
        if (res.data.content) {
          const schools = patternSchools(res.data.content);
          this.setState({
            schools: [...schools],
            page: res.data.number,
            size: res.data.size,
            totalElements: res.data.totalElements,
            totalPages: res.data.totalPages,
            loading: false,
          });

          this.EscolaFilter.handleFilterPersistence(filters);
        } else {
          this.setState({
            schools: [],
            page: PAGE,
            size: SIZE,
            totalElements: TOTAL_ELEMENTS,
            totalPages: TOTAL_PAGES,
            loading: false,
          });
        }
      })
      .catch(error => {
        const e = errors(error);
        this.Toast.setState({
          message: {
            message: e.message,
            type: e.type,
            open: true
          }
        })

        this.setState({ loading: false });
      })
  }

  // FILTROS
  filterData = (filters, isActive = true) => this.setState({ filtered: isActive, filters: [...removePagingAndSorting(filters)] }, () => this.loadData());

  // PÁGINA
  handlePage = page => this.setState({ page: page }, () => this.filterData(this.state.filters));

  // LINHAS POR PÁGINA
  handleRowsPerPage = (size, page) => this.setState({ size: size, page: page }, () => this.filterData(this.state.filters));

  // ORDENAÇÃO
  handleSort = (orderBy, order) => {
    if (this.state.sort.find(s => s.orderBy === orderBy)) {
        let newSort = this.state.sort.filter(s => s.orderBy !== orderBy);
        newSort.splice(this.state.sort.indexOf(this.state.sort.find(s => s.orderBy === orderBy)), 0, { orderBy: orderBy, order: order })
        this.setState({...this.state, sort: [...newSort], filtered: true });
    } else {
        this.setState({ ...this.state, sort: [...this.state.sort.filter(s => s.orderBy !== orderBy), { orderBy: orderBy, order: order }], filtered: true });
    }
  }
  handleClearSort = (orderBy) => {
      this.setState({ ...this.state, filtered: true, sort: orderBy ? [...this.state.sort.filter(s => s.orderBy !== orderBy)] : [{ orderBy: this.state.defaultOrderBy, order: ASC }] });
  };

  // TOTAL DE PAGINAS
  handleTotalPages = () => this.state.totalPages;

  // TOTAL DE ELEMENTOS
  handleTotalElements = () => this.state.totalElements;

  // VERIFICAR PERSISTENCIA NO FORMULARIO DE FILTROS
  handleFilterPersistence = () => this.EscolaFilter ? this.EscolaFilter.state ? this.EscolaFilter.handleFilterPersistence(this.state.filters) : null : null;

  componentDidMount() { this.loadData(); }

  render() {
    const pageName = 'Escolas';
    const links = [];

    const columns = [
      { label: 'INEP', name: 'cdMecEscola', func: null, key: true },
      { label: 'Escola', name: 'nmEscola', func: null, key: false },
      { label: 'UF', name: 'nmUf', func: null, key: false, ordering: false },
      { label: 'Município', name: 'nmMunicipio', func: null, key: false, ordering: false },
      { label: 'Total de Alunos Previstos', name: 'qtdAlunosPrevistosTotal', func: null, key: false, ordering: false },
      { label: 'Total de Alunos Participantes', name: 'qtdAlunosParticipantesTotal', func: null, key: false, ordering: false },
      { label: 'Evasão Total', name: 'evasaoTotal', func: isAfterDataProvaFase1(this.props.contexts) ? evasaoLimiterMask : () => "Prova Não Realizada", key: false, ordering: false },
    ];

    const actions = [
      {
        name: this.labelEditar,
        func: this.handleEditClick,
        icon: <EditOutlinedIcon />,
        disabled: this.disabledEditar,
      },
      {
        name: this.labelInscrever,
        func: this.handleInscreverClick,
        icon: <PlaylistAddOutlinedIcon />,
        disabled: this.disabledInscrever, 
      },
      {
        name: this.labelResponsavel,
        func: this.handleEditResponsibleClick,
        icon: <SupervisorAccountIcon />,
        disabled: this.disabledResponsavel,
      },
      {
        name: this.labelAtualizarSenha,
        func: this.handleOpenAtualizarSenhaClick,
        icon: <VpnKeyOutlinedIcon />,
        disabled: this.disabledAtualizarSenha,
      },
      {
        name: this.labelDownloadFase2,
        func: this.handleOpenDownloadFase2,
        icon: (id) => this.verificarSeEscolaPodeAcessarDownloadFase2(id) ? <LockOpenOutlinedIcon /> : <LockIcon />,
        disabled: this.disabledDownloadFase2,
      },
      {
        name: this.labelRecibo,
        func: this.handleViewReceipt,
        icon: <DescriptionIcon />,
        disabled: this.disabledRecibo,
      },
      {
        name: this.labelDashboard,
        func: this.handleViewDashboard,
        icon: <LaptopMacIcon />,
        disabled: this.disabledDashboard,
      },
      {
        name: this.labelRemoverInscricao,
        func: this.handleRemoverInscricao,
        icon: <HighlightOffOutlinedIcon />,
        disabled: this.disabledRemoverInscricao,
        color: "secondary"
      },
      {
        name: this.labelExcluir,
        func: this.handleExcluir,
        icon: <DeleteOutlinedIcon />,
        disabled: this.disabledExcluir,
        color: "secondary"
      },
    ];

    this.handleFilterPersistence();

    return (
      <Layout>
        <Toast parentRef={this.setToast} />
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Breadcrumbs links={links} active={pageName} />
          </Grid>
        </Grid>
        <Title>{pageName}</Title>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <EscolaFilter
              parentRef={this.setEscolaFilter}
              handleFilterChange={this.filterData}
            />
            <Grid container spacing={3}>
              <AuthorizedElement roles={[__ESCOLA_ADICIONAR]}>
                <ButtonAdd
                  to={{ pathname: '/admin/escola/adicionar', state: { history: { path: '/admin/escola', state: this.state, } } }}
                  title="Adicionar Escola"
                />
              </AuthorizedElement>
              <AuthorizedElement roles={[__ESCOLA_EXPORTAR]}>
                {this.state.filters.length > 3 &&
                  <ButtonExport
                    title="Exportar Planilha"
                    onClick={this.handleExportPlan}
                  />
                }
              </AuthorizedElement>
            </Grid>
            <Table
              columns={columns}
              tableData={this.state.schools}
              actions={actions}
              page={this.state.page}
              handlePage={this.handlePage}
              handleTotalPages={this.handleTotalPages}
              handleTotalElements={this.handleTotalElements}
              rowsPerPage={this.state.size}
              handleRowsPerPage={this.handleRowsPerPage}
              sort={this.state.sort}
              handleSort={this.handleSort}
              handleClearSort={this.handleClearSort}
              loading={this.state.loading}
            />
          </Grid>
        </Grid>

        {AuthorizedFunction([__ESCOLA_EDITAR_SENHA]) &&
          <DialogChangePassword parentRef={this.setDialogChangePassword} />
        }

        {AuthorizedFunction([__ESCOLA_EDITAR]) &&
          <DialogHabilitarDownloadFase2
            parentRef={this.setDialogHabilitarDownloadFase2}
            handleConfirm={this.handleHabilitarDownloadFase2}
          />
        }

        {AuthorizedFunction([__ESCOLA_REMOVER]) &&
          <DialogRemoverEscola
            parentRef={this.setDialogRemoverEscola}
            handleConfirm={this.handleRemoverEscolaConfirm}
          />
        }

        {AuthorizedFunction([__INSCRICAO_REMOVER]) &&
          <DialogRemoverInscricao
            parentRef={this.setDialogRemoverInscricao}
            handleConfirm={this.handleRemoverInscricaoConfirm}
          />
        }
      </Layout>
    )
  }
}

const mapStateToProps = state => ({ contexts: state.contexts });
const mapDispatchToProps = dispatch => (bindActionCreators({ loadContext }, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Escola));